import { render, staticRenderFns } from "./full-comparison-table.vue?vue&type=template&id=daa97d38"
import script from "./full-comparison-table.vue?vue&type=script&lang=js"
export * from "./full-comparison-table.vue?vue&type=script&lang=js"
import style0 from "./full-comparison-table.vue?vue&type=style&index=0&id=daa97d38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports